import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'concat' })
export class ConcatPipe implements PipeTransform {
  transform(list1: any, list2: any) {
    return list1.concat(list2);
  }
}
